export function moment(date) { 
    return window.moment(date).format('DD MMM YYYY');
}

export function notFound(e){
    if (e.message.toLowerCase() === 'network error'){
        this.$router.push({ name: '404' });
    };
}